module.exports = __webpack_public_path__ + "img/kma_gallery3.df412da4.jpg";